import TooltipWrapper from '@/components/Tooltip/components/TooltipWrapper';
import { LinkContent, Name, TextContent } from './BoardDetail.styles';

interface TextBoardProps {
  name: string;
  displayText: string;
}

const TextBoard: React.FC<TextBoardProps> = ({ name, displayText }) => {
  return (
    <div>
      <Name>{name}</Name>
      <TooltipWrapper value={displayText}>
        <TextContent>{displayText}</TextContent>
      </TooltipWrapper>
    </div>
  );
};

interface LinkBoardProps extends TextBoardProps {
  href: string;
  openInNewTab?: boolean;
}

const LinkBoard: React.FC<LinkBoardProps> = ({ name, href, displayText, openInNewTab }) => {
  const target = openInNewTab ? '_blank' : '_self';

  return (
    <div>
      <Name>{name}</Name>
      <TooltipWrapper value={displayText}>
        <LinkContent href={href} target={target}>
          {displayText}
        </LinkContent>
      </TooltipWrapper>
    </div>
  );
};

export { LinkBoard, TextBoard };
